import React from 'react';

export enum POPUP_SIZE {
    SMALL = 'small',
    MEDIUM = 'medium',
    BIG = 'big',
}

export enum THEME {
    DARK = 'dark',
    LIGHT = 'light',
}

export interface PopupProps {
    header?: string | React.ReactNode
    children?: string | React.ReactNode
    footer?: string | React.ReactNode
    size?: POPUP_SIZE
    theme?: THEME
    wrapperHandler?: () => void
    closePopupHandler?: (closedValue: boolean) => void,
}

export class Popup extends React.Component<PopupProps> {}
